import { env } from './env';

/**
 * A Studio master's own domain serves their showcase at "/" (Phase 9.12).
 *
 * The same SPA is served on every host; on one that is not the platform's
 * own, main.tsx asks the API which showcase it belongs to before mounting and
 * records the answer here, where the router and the showcase page read it.
 */
let servedSlug: string | null = null;

const bare = (host: string) => host.toLowerCase().replace(/^www\./, '');

/** The host, when it is someone's own domain rather than ours, localhost or an IP. */
export const customDomainHost = (hostname: string): string | null => {
  const host = bare(hostname);
  const own = [env.appUrl, env.siteUrl].map((url) => bare(new URL(url).hostname));
  const ours = own.some((domain) => host === domain || host.endsWith(`.${domain}`));
  const local = host === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(host);

  return ours || local ? null : hostname.toLowerCase();
};

export const setServedShowcase = (slug: string | null) => {
  servedSlug = slug;
};

/** The showcase this deployment is serving on a master's own domain, or null. */
export const servedShowcase = (): string | null => servedSlug;
